<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"\n"' class="col-lg-6 col-sm-12 m-0 p-0 mx-auto mb-2" >
                <template #default>   <m-video v-bind='{...{"controls":false,"videoSrc":"https:\/\/api.geramyan.com\/storage\/bargiri\/Select.mp4","autoplay":true,"muted":true,"loop":true,"poster":null},...{}}' :style='"object-fit: cover;\nborder-radius: 25px;\n\n\n"' class="col-lg-12 m-0 p-0  shadow" ></m-video></template>
                </m-div><m-categories-313 v-bind='{...{"categoryItemClass":"col-lg-4 my-2","linkType":"Products","categoryCardName":"mCategoryCard315"},...{}}' :style='""' class="" ></m-categories-313>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mVideo from '@moeinmdn/miw-alpha-components/src/package/Tags/Video'; import mCategories313 from '@moeinmdn/miw-alpha-components/src/package/Category/Categories/Categories313';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mVideo,mCategories313 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
